export default __webpack_public_path__ + "static/media/stressLevel.268cbcb2.gif";